import React from "react";

import { LoaderContainer, RotatingLoader } from "./Loading.styles";

export const Loading = () => {
    return (
        <LoaderContainer>
            <RotatingLoader />
        </LoaderContainer>
    );
};

export default Loading;
